module.exports = __webpack_public_path__ + "img/SAVE_PAY.00351816.svg";